import { useEffect, useState } from "react";
import "./Warriors.css";
import { getAllCharacterApi } from "../../services/warriorService";
import { toast } from "react-toastify";

export function Warriors(props) {
  const [warriors, setWarriors] = useState([]);

  useEffect(() => {
    getBlueWarriors();
    // getAllCharacterApi().then((data) => {
    //   if(data){
    //     setWarriors(data);
    //   }
    // }).catch((error) => {
    //   if (error.message === "Failed to fetch") {
    //     toast.info("Can not connect server", { theme: "colored" });
    //   }
    // });
  }, []);

  function getBlueWarriors() {
    let warriorList = [
      {
        _id: {
          $oid: "6500ab2eb24a09040ff88fbb",
        },
        characterName: "copenl",
        avatar: "warrior1",
        userId: "6500ab2db24a09040ff88fba",
        overall: 78,
        money: 39915,
        warriorType: "Balanced",
        wifeInformation: {
          wifeId: "Gertrud",
          wifeName: "Gertrud",
          avatar: "lady3",
        },
        hunger: "None",
        train: "Shield",
        work: "None",
        workId: "66ff44f0055bfa2a4de19f64",
        workInformation: {
          tribeId: "64fd7057081fbaf089f3856f",
          tribeName: "Bran",
          tribeColor: "2d6ed6",
          warriorType: "Balanced",
          warriorLevel: 2,
          warbandPosition: 1,
          warbandOrder: 1,
          status: 0,
        },
        warlordCharacter: false,
        tribeInformation: {
          tribeId: "64fd7057081fbaf089f3856f",
          tribeName: "Bran",
          tribeColor: "2d6ed6",
        },
        prestige: 48,
        warlordPrestige: 135,
        characterSkillTreeId: "6500ab2eb24a09040ff88fbc",
        characterInventoryId: "6500ab2fb24a09040ff88fbd",
      },
      {
        _id: {
          $oid: "6500aca2b24a09040ff88fc2",
        },
        characterName: "fafekar",
        avatar: "warrior11",
        userId: "6500aca2b24a09040ff88fc1",
        overall: 14,
        money: 7810,
        warriorType: "Attack",
        wifeInformation: {
          wifeId: "Gertrud",
          wifeName: "Gertrud",
          avatar: "lady3",
        },
        hunger: "None",
        train: "Attack",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: {
          tribeId: "64fd7057081fbaf089f38570",
          tribeName: "Kalmar",
          tribeColor: "8c5154",
        },
        prestige: 0,
        warlordPrestige: 21,
        characterSkillTreeId: "6500aca2b24a09040ff88fc3",
        characterInventoryId: "6500aca2b24a09040ff88fc4",
      },
      {
        _id: {
          $oid: "6500ade2b24a09040ff88fc9",
        },
        characterName: "duhiti",
        avatar: "warrior17",
        userId: "6500ade2b24a09040ff88fc8",
        overall: 22,
        money: 9520,
        warriorType: "Balanced",
        wifeInformation: {
          wifeId: "Bodil",
          wifeName: "Bodil",
          avatar: "lady2",
        },
        hunger: "None",
        train: "Strength",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: {
          tribeId: "64fd7057081fbaf089f38571",
          tribeName: "Kopen",
          tribeColor: "d62d8d",
        },
        prestige: 0,
        warlordPrestige: 24,
        characterSkillTreeId: "6500ade2b24a09040ff88fca",
        characterInventoryId: "6500ade2b24a09040ff88fcb",
      },
      {
        _id: {
          $oid: "65014e08ab1b3ec83a6e9370",
        },
        characterName: "vetic",
        avatar: "warrior14",
        userId: "65014e08ab1b3ec83a6e936f",
        overall: 28,
        money: 80,
        warriorType: "Balanced",
        wifeInformation: {
          wifeId: "Bodil",
          wifeName: "Bodil",
          avatar: "lady2",
        },
        hunger: "None",
        train: "Strength",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: null,
        prestige: 0,
        warlordPrestige: 0,
        characterSkillTreeId: "65014e08ab1b3ec83a6e9371",
        characterInventoryId: "65014e08ab1b3ec83a6e9372",
      },
      {
        _id: {
          $oid: "65014f03ab1b3ec83a6e937d",
        },
        characterName: "zatoro",
        avatar: "warrior5",
        userId: "65014f03ab1b3ec83a6e937c",
        overall: 14,
        money: 35380,
        warriorType: "Balanced",
        wifeInformation: {
          wifeId: "Ingrid",
          wifeName: "Ingrid",
          avatar: "lady6",
        },
        hunger: "None",
        train: "Mental",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: null,
        prestige: 0,
        warlordPrestige: 0,
        characterSkillTreeId: "65014f03ab1b3ec83a6e937e",
        characterInventoryId: "65014f03ab1b3ec83a6e937f",
      },
      {
        _id: {
          $oid: "6522aa034e433d2f1d697c20",
        },
        characterName: "yovuj",
        avatar: "warrior1",
        userId: "6522aa034e433d2f1d697c1d",
        overall: 0,
        money: 100,
        warriorType: "Balanced",
        wifeInformation: null,
        hunger: "None",
        train: "None",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: null,
        prestige: 0,
        warlordPrestige: 0,
        characterSkillTreeId: "6522aa044e433d2f1d697c22",
        characterInventoryId: "6522aa044e433d2f1d697c23",
      },
      {
        _id: {
          $oid: "6522aa034e433d2f1d697c1f",
        },
        characterName: "zijegcf",
        avatar: "warrior1",
        userId: "6522aa034e433d2f1d697c1e",
        overall: 0,
        money: 100,
        warriorType: "Balanced",
        wifeInformation: null,
        hunger: "None",
        train: "None",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: null,
        prestige: 0,
        warlordPrestige: 0,
        characterSkillTreeId: "6522aa044e433d2f1d697c21",
        characterInventoryId: "6522aa044e433d2f1d697c24",
      },
      {
        _id: {
          $oid: "652a5f37833fc6afeabf1094",
        },
        characterName: "soheda",
        avatar: "warrior1",
        userId: "652a5f37833fc6afeabf1093",
        overall: 0,
        money: 100,
        warriorType: "Balanced",
        wifeInformation: null,
        hunger: "None",
        train: "None",
        work: "None",
        workId: null,
        workInformation: null,
        warlordCharacter: false,
        tribeInformation: null,
        prestige: 0,
        warlordPrestige: 0,
        characterSkillTreeId: "652a5f37833fc6afeabf1095",
        characterInventoryId: "652a5f37833fc6afeabf1096",
      },
    ];

    let warriorList2 = [
      {
        id: 1,
        characterName: "copenl",
        avatar: "warrior1",
        overall: 78,
        warriorType: "Balanced",
      },
      {
        id: 2,
        characterName: "fafekar",
        avatar: "warrior11",
        overall: 14,
        warriorType: "Attack",
      },
      {
        id: 3,
        characterName: "duhiti",
        avatar: "warrior17",
        overall: 22,
        warriorType: "Balanced",
      },
    ];
    setWarriors(warriorList);
  }

  let rankingCounter = 0;
  let warriorTableRows = warriors.map((warrior) => {
    rankingCounter++;
    return (
      <tr key={warrior.id}>
        <th scope="row">{rankingCounter}</th>
        <td className="text-capitalize">
          <div className="d-flex align-items-center">
            <div>
              <img
                width="60px"
                className="game-menu-image warrior-rank-image"
                src={`images/character/${warrior.avatar}.png`}
                alt="warrior portrait"
              />
            </div>
            <div className="ms-3">{warrior.characterName}</div>
          </div>
        </td>
        <td className="general-table-td">{warrior.overall}</td>
        <td className="general-table-td">{warrior.warriorType}</td>
      </tr>
    );
  });

  return (
    <div
      className={`general-game-container mx-auto p-3 ${
        props.innerContainer ? "inner-container " : "mt-3 "
      } `}
    >
      <h2>Warriors</h2>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Warrior</th>
              <th scope="col">Overall</th>
              <th scope="col">Warrior Type</th>
            </tr>
          </thead>
          <tbody>{warriorTableRows}</tbody>
        </table>
      </div>
    </div>
  );
}
